import { URLS } from "@app/shared";
import { LinkedinIcon, TwitterIcon } from "@design-system/icons";

export const headerLinks = [
  {
    id: 1,
    title: "aboutUs",
    children: [
      {
        title: "overview",
        href: URLS.aboutUs.root,
      },
      {
        title: "visionAndMission",
        href: URLS.aboutUs.root + "#vision-mission-section",
      },
      {
        title: "aboutUsPage.leadership.navigation.boardOfDirectors",
        href: URLS.aboutUs.root + "?tab=boardOfDirectors#leadership-section",
      },
      {
        title: "aboutUsPage.leadership.navigation.leadershipWord",
        href: URLS.aboutUs.root + "?tab=leadershipWord#leadership-section",
      },
      {
        title: "aboutUsPage.leadership.navigation.socialResponsibility",
        href:
          URLS.aboutUs.root + "?tab=socialResponsibility#leadership-section",
      },
      {
        title: "subsidiaries",
        href: URLS.aboutUs.root + "?tab=subsidiaries#leadership-section",
      },
    ],
  },
  {
    id: 2,
    title: "sectors",
    children: [
      {
        title: "fabricatedSector",
        href: URLS.sectors.view("fabricated-sector"),
      },
      {
        title: "airConditioningSector",
        href: URLS.sectors.view("air-conditioning-sector"),
      },
      {
        title: "insulationSector",
        href: URLS.sectors.view("insulation-sector"),
      },
      {
        title: "constructionSector",
        href: URLS.sectors.view("construction-sector"),
      },
    ],
  },
  {
    id: 3,
    title: "investorRelations",
    children: [
      {
        title: "home",
        href: URLS.investor.root,
      },
      {
        title: "aboutUs",
        href: URLS.investor.factSheet,
        children: [
          {
            title: "investmentCase.title",
            href: URLS.investor.investmentCase,
          },
          {
            title: "factSheet",
            href: URLS.investor.factSheet,
          },
        ],
      },
      {
        title: "financialInformation",
        href: URLS.investor.financialInfo,
        children: [
          {
            title: "keyFigures",
            href: URLS.investor.keyFigures,
          },
          {
            title: "financialAnnouncements",
            href: `${URLS.investor.financialInfo}?tab=financialAnnouncements`,
          },
          {
            title: "financialStatements",
            href: `${URLS.investor.financialInfo}?tab=statements`,
          },
          {
            title: "financialReports",
            href: `${URLS.investor.financialInfo}?tab=reports`,
          },
        ],
      },
      {
        title: "shareholderInformation.title",
        href: URLS.investor.shareInformation,
        children: [
          {
            title: "shareInformation",
            href: URLS.investor.shareInformation,
          },
          {
            title: "dividendInformation",
            href: URLS.investor.dividendInformation,
          },
        ],
      },
      {
        title: "companyAnnouncements",
        href: URLS.investor.companyAnnouncements,
      },
      {
        title: "financialCalendar",
        href: URLS.investor.financialCalendar,
      },
      {
        title: "analystCoverage",
        href: URLS.investor.analysisCoverage,
      },
      {
        title: "corporateGovernance",
        children: [
          {
            title: "boardOfDirectors",
            href: URLS.investor.boardOfDirectors,
          },
          {
            title: "generalAssembly",
            href: URLS.investor.generalAssembly.root,
          },
          {
            title: "governanceDocuments",
            href: URLS.investor.governanceAndRegulatoryDocuments,
          },
        ],
      },
      {
        title: "emailSubscriptionCenter",
        href: URLS.investor.emailSubscriptionCenter,
      },
      {
        title: "contactIr",
        href: URLS.investor.contactIr,
      },
    ],
  },
  {
    id: 4,
    title: "mediaCenter",
    children: [
      {
        title: "pressReleases",
        href: URLS.pressReleases.root,
      },
      // {
      //   title: "newsletters",
      //   href: URLS.newsletters.root,
      // },
      // {
      //   title: "mediaKit",
      //   href: URLS.mediaKit,
      // },
    ],
  },

  {
    id: 5,
    title: "careers",
    href: URLS.careers,
  },
  {
    id: 6,
    title: "contactUs",
    href: URLS.contactUs,
  },
];

export const footerLinks = [
  {
    id: 1,
    title: "ourCompany",
    children: [
      {
        title: "overview",
        href: URLS.aboutUs.root,
      },
      {
        title: "visionAndMission",
        href: URLS.aboutUs.root + "#vision-mission-section",
      },
      {
        title: "aboutUsPage.leadership.navigation.boardOfDirectors",
        href: URLS.aboutUs.root + "?tab=boardOfDirectors#leadership-section",
      },
      {
        title: "aboutUsPage.leadership.navigation.leadershipWord",
        href: URLS.aboutUs.root + "?tab=leadershipWord#leadership-section",
      },
      {
        title: "aboutUsPage.leadership.navigation.socialResponsibility",
        href:
          URLS.aboutUs.root + "?tab=socialResponsibility#leadership-section",
      },
      {
        title: "subsidiaries",
        href: URLS.aboutUs.root + "?tab=subsidiaries#leadership-section",
      },
    ],
  },
  {
    id: 2,
    title: "investorRelations",
    children: [
      {
        title: "investorRelations",
        href: URLS.investor.root,
      },
      // {
      //   title: "basicInfo.title",
      //   href: URLS.investor.basicInfo,
      // },

      // {
      //   title: "financialInformation",
      //   href: URLS.investor.financialInfo,
      // },

      // {
      //   title: "generalAssembly",
      //   href: URLS.investor.generalAssembly.root,
      // },
    ],
  },
  {
    id: 3,
    title: "media",
    children: [
      {
        title: "pressReleases",
        href: URLS.pressReleases.root,
      },
      // {
      //   title: "newsletters",
      //   href: URLS.newsletters.root,
      // },
    ],
  },
];

export const footerSocialLinks = [
  {
    Icon: LinkedinIcon,
    href: "https://www.linkedin.com/company/senaatصناعات/",
  },
  {
    Icon: TwitterIcon,
    href: "https://x.com/Senaat",
  },
  // {
  //   Icon: FacebookIcon,
  //   href: "https://www.facebook.com/senaatco",
  // },
];

export const linksDrawerBottom = [
  {
    title: "careers",
    href: URLS.careers,
  },
  {
    title: "contactUs",
    href: URLS.contactUs,
  },
  {
    title: "termsOfUse",
    href: URLS.termsOfUse,
  },
  {
    title: "privacyPolicy",
    href: URLS.privacyPolicy,
  },
];
